import apiClient from "../../utils/api.client";
import { getSaaId } from "../../utils/session.utils";

const saaServiceName = process.env.REACT_APP_SAA_SERVICE_NAME || "saaServices";

export const getCashControl = async (
  organizationId,
  fecha,
  agencia,
  subagencia,
) => {
  try {
    const saaId = getSaaId();
    const subParam = subagencia != null ? `&subagencia=${subagencia}` : "";
    const response = await apiClient.get(
      `saaServices/${saaServiceName}/services/abaco/controlesCaja?organizacionId=${saaId}&fecha=${fecha}&agencia=${agencia}${subParam}`,
    );
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getCashControl EP: ", error);
    throw error;
  }
};

export const getTJcontrol = async (
  organizationId,
  fechadesde,
  fechahasta,
  agencia,
  subagencia,
) => {
  try {
    const saaId = getSaaId();
    const subParam = subagencia != null ? `&subagencia=${subagencia}` : "";
    const response = await apiClient.get(
      `/saaServices/${saaServiceName}/services/abaco/controltj?organizacionId=${saaId}&agencia=${agencia}${subParam}&fechadesde=${fechadesde}&fechahasta=${fechahasta}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error at getTJcontrol EP: ", error);
    throw error;
  }
};

export const getCierreTJ = async (organizationId, fecha, agencia, subagencia, tipo) => {
  try {
    const saaId = getSaaId();
    const subParam = subagencia != null ? `&subagencia=${subagencia}` : "";
    const tipoParam = tipo ? `&tipo=${tipo}` : "";
    const response = await apiClient.get(
      `/saaServices/${saaServiceName}/services/abaco/cierretj?organizacionId=${saaId}&fecha=${fecha}&agencia=${agencia}${subParam}${tipoParam}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error at getCierreTJ EP: ", error);
    throw error;
  }
};
